import _ from 'lodash'
import orderStateApi from '@/api/order-state'
import store from '@/store'
import form from './form'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  totalCount: 0,
  errors: [],
  loading: false,
  filters: {
    pageNumber: 1,
    pageSize: 10,
    searchQuery: '',
    sortBy: '',
    sortDesc: false
  }
}

const getters = {
}

const actions = {
  fetchList({ commit }) {
    state.loading = true;
    orderStateApi.getAll({...state.filters})
      .then(( {data} ) => commit('SET_LIST', data))
  },
  delete({ commit }, id) {
    return orderStateApi.delete(id)
      .then(() => commit('ORDER_STATE_REMOVED', id))
      .catch((error) => {
        commit('ORDER_STATE_REMOVE_FAILED', { id, errors: error.response.data.errors });
        throw error;
      });
  }
}

const mutations = {
  SET_LIST(state, {items, metadata}) {
    state.list = items;
    state.totalCount = metadata.totalItemCount;
    state.loading = false;
  },
  ORDER_STATE_REMOVED(state, id) {
    store.dispatch('orderState/fetchList');
    store.dispatch('message/success', 'CONTACT.success')
  },
  ORDER_STATE_REMOVE_FAILED(state, { id, errors }) {
    store.dispatch('message/error', 'CONTACT.removeFailure')
    state.errors = errors;
  },
  CLEAR_ERRORS(state) {
    state.errors = [];
  },
  ...generateFormHandlerMutations(state)
}

const modules = {
  form
}

const watchers = [
  [state => state.orderState.filters, _.debounce(async () => await store.dispatch('orderState/fetchList'), 250), { immediate: false, deep: true }]
]

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers
}
